var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"face-direction-message",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isPaidy: _vm.$store.getters['auth/isPaidy'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh'
  }},[_c('transition',{attrs:{"name":"fade"}},[(_vm.caution && !_vm.isStart)?_c('div',{staticClass:"cautionbox",domProps:{"innerHTML":_vm._s(_vm.caution)}}):_vm._e()]),_c('div',{staticClass:"messagebox",class:{ start: _vm.isStart, success: _vm.isSuccess }},[_c('div',{staticClass:"messagebox-message",domProps:{"innerHTML":_vm._s(_vm.message)}}),(_vm.isStart)?_c('FooterButton',{staticClass:"messagebox-button",attrs:{"enabled":_vm.enabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }